import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy
} from '@angular/core';
import { ScreenModule } from '../../screen.module';
import { BaseScreenComponent } from '../../abstract-components/base-screen.component';
import { ScreenCreationDialogComponent } from '../../modals/screen-creation-dialog/screen-creation-dialog.component';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { EventService } from '~app/app/~shared/services/event.service';
import { filter, tap } from 'rxjs';
import { GlobalEvent } from '~core/models/shared.models';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'screen-list-page',
  standalone: true,
  imports: [ScreenModule],
  templateUrl: './screen-list-page.component.html',
  styleUrl: './screen-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreenListPageComponent
  extends BaseScreenComponent
  implements AfterContentInit, OnDestroy
{
  private _dialogService = inject(DialogService);
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;
  isLoading$ = this._resourceFacade.isLoading$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  ngAfterContentInit(): void {
    this._resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this._resourceFacade.resetState();
  }

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }

  openCreateScreenDialog(): void {
    this._dialogService.open({
      component: ScreenCreationDialogComponent,
      fullscreen: true
    });
  }

  onSearch(searchText: string | null): void {
    this._resourceFacade.applyFilters({
      name: searchText ? `like(%${searchText}%)` : null
    });
    this._resourceFacade.getData({ refresh: true });
  }

  onFilterChange(filters: Record<string, unknown>): void {
    this._resourceFacade.applyFilters(filters);
    this._resourceFacade.getData({ refresh: true });
  }
}
